import { Controller } from '@hotwired/stimulus';
import Leaflet from 'leaflet';
import markerUrl from '../../images/icons/map-marker.svg';
import markerPrimaryUrl from '../../images/icons/map-marker--primary.svg';

let mapMarkers = [];

export default class extends Controller {
    static get targets () {
        return ['map', 'trigger'];
    }

    initialize() {
        this._markers = [];
        this._map = null;
        this._initialPosition = [51.505, -0.09];
        this._initialZoom = 3;
    }

    mapTargetConnected(element) {
        if (element.dataset.markers) {
            this._markers = JSON.parse(element.dataset.markers);

            if (this._markers[0]) {
                this._initialPosition = [this._markers[0].latitude, this._markers[0].longitude];
                this._initialZoom = this._markers[0].zoom;
            }
        }

        this._map = Leaflet.map(element, {
            center: this._initialPosition,
            zoom: this._initialZoom,
            scrollWheelZoom: false,
            zoomControl: false
        });


        Leaflet.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            id: 'cpartner/clivcfsq400gm01qyeh4sg6d0',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1IjoiY3BhcnRuZXIiLCJhIjoiY2w5OGU3MzFhMm9tajNucW1lZzk2czJ0NiJ9.vWvne5qpcbkQWYPvUHXzug',
        }).addTo(this._map);

        this._markers.forEach(marker => {
            if (marker.latitude && marker.longitude && marker.level === 2) {
                if (marker.main === true) {
                    mapMarkers[marker.id] = Leaflet.marker([marker.latitude, marker.longitude], {
                        icon: new (Leaflet.Icon.extend({
                            options: {
                                iconSize: [100, 100]
                            },
                        }))({ iconUrl: markerPrimaryUrl }),
                    }).addTo(this._map);
                } else {
                    mapMarkers[marker.id] = Leaflet.marker([marker.latitude, marker.longitude], {
                        icon: new (Leaflet.Icon.extend({
                            options: {
                                iconSize: [60, 60]
                            },
                        }))({ iconUrl: markerUrl }),
                    }).addTo(this._map);
                }
            }
        });
    }

    triggerTargetConnected(element) {
        element.addEventListener('click', (e) => {
            e.preventDefault();
            const id = element.getAttribute('href');
            const marker = this._markers.filter(m => m.id === id);

            if (marker.length) {
                this._map.flyTo({
                    lat: marker[0].latitude,
                    lng: marker[0].longitude
                }, marker[0].zoom);

                this.triggerTargets.forEach(trigger => {
                    if (trigger.dataset.activate) {
                        trigger.parentElement.classList.remove('active');
                    }
                });

                if (element.dataset.activate) {
                    element.parentElement.classList.add('active');
                }
            }
        });
    }
}
